let _this;
let LetterRow = 0;
let LetterRowSignNum = 48;
import previewIncidentPDF from "./previewIncidentPDF.vue";
import previewFaceTrackingPDF from "./previewFaceTrackingPDF.vue";
import filterList from '../commonComponents/filterParamsList.vue'
export default {
  name: 'generateReport',
  components: {
    previewIncidentPDF,
    previewFaceTrackingPDF,
    filterList
  },
  data() {
    return {
      generateInfo: {
        reportName: "",
        remark: "",
        companyLogoBase64:"",
        letterHeader: "",
        attachments: []
      },
      generateModal: false,
      previewInfo: {
        head:{},
        details:[],
        titleData:[],
      }, /*预览信息*/
      logoFileName:"",
      incidentList: [], /*显示的事件列表*/
      preViewModal: false,
      isFaceTrack:false,/*Track and Trace报表生成*/
      faceTrackingInfo:{}, /*Track and Trace信息 */
      traceResultTypes:[], /*Track and Trace结果类型*/
      traceResultArr:["General Access","FR Verification","Face Detection"],
      userInfo:{}, /*Track and Trace用户信息*/
      totalAmount : 0,
      paramsData:{},
      checkedData:[],
      downloadType:0,
      generateType: 0, /*0:Selected; 1:Filtered; 2:All*/
      isMsgDetail: false,
      detailText: '',
      pageSource: 0,
      usableReportTypes:[0, 1], /*可用的permissionType的值*/
      isAll:false,/*当前是否为所有报表下载*/
      exportVideo:false,
      limitFlag:false,
      /*** 自动发送邮件 ***/
      isAutoSendEmail:false,
      receiverFlag: false,/*Receiver表单验证*/
      allRoleList:[], /*所有角色*/
      allAccountGroupList:[],/*所有账号组*/
      allAccountList: [],/*所有账号*/
      selectedRoles:[],
      selectedAccountGroups:[],
      selectedAccounts:[],
      accountGroupName:'',/*账号组搜索词*/
      accountName: '',/*管理员搜索词*/
      roleName:'',/*角色搜索词*/
      editEmailModal: false,/*编辑邮箱模态框*/
      cursorPosition:0,/*光标位置*/
      emailSubject:'',
      emailContent:'',
      emailFlag: false,
      emailText: '',/*邮箱内容填写*/
      emailTitle:'',
      emailTitleFlag: false,
      reciverData:{
        enabledPaging:false,
        sortName:'name',
        sortType:0,
        name:'',
      },
      receivers:[],
      videoCount:0,
      //是否有特殊字符 
      hasSpecialCharacters:false,
      loadVideoRoles:['M_ViewMyAlarmVideo','M_ViewMyNotificationVideo','M_ViewMyTaskVideo','M_ViewIncidentVideo','M_ViewIncidentNotificationVideo','M_ViewIncidentTasksVideo'],
      loadVideoRole:'',
    }
  },
  mounted() {
    _this = this;
    // pageSource: 进入来源页面,用于区分权限. 0或undefined是incident report. 1是消息中心. 2是即时推送消息. 3是My Incident. 4是Alarm Map. 6是My Incident中My Notification 10是Track and Trace 11是 Incident Report->System Notifications、12是Incident Report->Tasks
    eventBus.$on('reportGeneration', (checkedData, totalAmount, paramsData, searchParams, isMsgDetail, pageSource, incidentCategory) => {
      _this.hasSpecialCharacters = false;
      _this.loadVideoRole = _this.loadVideoRoles[incidentCategory]
      _this.generateInfo = {
        formatType: 0,
        reportName: "",
        remark: "",
        companyLogoBase64: "",
        letterHeader: "",
        attachments: [],
        permissionType: 0,
        isAutoSendEmail:false,
      };
      _this.emailSubject='',
        _this.emailContent='',
        _this.emailFlag= false,
        _this.emailText= '',/*邮箱内容填写*/
        _this.emailTitle='',
        _this.emailTitleFlag= false,
        _this.reciverData ={
          enabledPaging:false,
          sortName:'name',
          sortType:0,
          name:'',
        };
      _this.receivers = [];
      _this.limitFlag = false;
      _this.exportVideo = false;
      _this.pageSource = pageSource;
 
      _this.getUsableReportType(incidentCategory);
      _this.isFaceTrack = false;
      let dataIds = checkedData.map(v=>v.id)
      if(dataIds && dataIds[0] === undefined){
        _this.isAll = true;
      }else {
        _this.isAll = false;
      }
      if( checkedData && checkedData.length && !_this.isAll){
        _this.generateType = 0;
      }else if( paramsData && paramsData.searchInfo.length > 0 ){
        _this.generateType = 1;
      }else{
        _this.generateType = 2;
      }
      _this.checkedData = checkedData;
      _this.totalAmount = totalAmount;
      _this.paramsData = paramsData;
      _this.searchParams = JSON.parse( JSON.stringify( searchParams ) );
      _this.isMsgDetail = isMsgDetail;
      if( _this.isMsgDetail ){
        _this.detailText = checkedData[0].uniqueId + ' - ' + checkedData[0].incidentName;
      }
      _this.generateModal = true;
      LetterRow = 0;
    });
    eventBus.$on('faceTrackingReportGeneration', (obj)=>{
      _this.hasSpecialCharacters = false;
      _this.generateInfo = {
        formatType: 0,
        reportName: "",
        remark: "",
        companyLogoBase64: "",
        letterHeader: "",
        attachments: [],
        permissionType: 0
      };
      _this.pageSource = 10;
      _this.getUsableReportType();
      _this.isFaceTrack = true;
      _this.generateType = 1;
      _this.checkedData = [];
      _this.faceTrackingInfo = JSON.parse( JSON.stringify( obj ) );
      _this.searchParams = JSON.parse( JSON.stringify( obj.searchParams ) );
      _this.isMsgDetail = false;
      _this.generateModal = true;
      LetterRow = 0;
    })
  },
  beforeDestroy() {
    eventBus.$off('reportGeneration');
    eventBus.$off('faceTrackingReportGeneration');
  },
  methods: {
    // 获取可选的Report Type
    getUsableReportType: function(incidentCategory){
      let privateCode = "",
      publicCode = "",
      usableReportTypes = [];
      console.log(_this.pageSource,'_this.pageSource;');
      let pageSource = _this.pageSource;
      if( pageSource === 1 || pageSource === 2 || pageSource === 3 || pageSource === 4 || pageSource === 6){
        let publicMap = {
          0: 'M_GeneratePublicMyAlarmReport',
          1: 'M_GeneratePublicMyNotificationReport',
          2: 'M_GeneratePublicMyTaskReport',
        };
        let privateMap = {
          0: 'M_GeneratePrivateMyAlarmReport',
          1: 'M_GeneratePrivateMyNotificationReport',
          2: 'M_GeneratePrivateMyTaskReport',
        };
        publicCode = publicMap[incidentCategory];
        privateCode = privateMap[incidentCategory];
      }else if( pageSource === 10 ){
        publicCode = "M_GenerateFaceTrackingPublicReport";
        privateCode = "M_GenerateFaceTrackingPrivateReport";
      }else if( pageSource === 11 ){
        publicCode = "M_GeneratePublicIncidentNotificationReport";
        privateCode = "M_GeneratePrivateIncidentNotificationReport";
      }else if( pageSource === 12 ){
        publicCode = "M_GeneratePublicIncidentTasksReport";
        privateCode = "M_GeneratePrivateIncidentTasksReport";
      }else if( pageSource === 13 ){
        publicCode = "M_GeneratePublicIncidentReport";
        privateCode = "M_GeneratePrivateIncidentReport";
      }
      if( !publicCode ){
        usableReportTypes = [0, 1];
      }else{
        if( _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf( publicCode ) > -1 ){
          usableReportTypes.push( 0 );
        }
        if( _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf( privateCode ) > -1 ){
          usableReportTypes.push( 1 );
          if( usableReportTypes.length === 1 ){
            _this.generateInfo.permissionType = 1;
          }
        }
      }
      _this.usableReportTypes = usableReportTypes;
    },
    // 切换pdf
    changeReportType:function (type) {
      if(type === 1){
        _this.getDefaultInfo();
      }else {
        _this.limitFlag = false;
      }
    },
    //删除勾选的事件
    deleteItem:function(id){
      if(_this.checkedData.length === 1){
        this.messageNotice("error", 'Please keep at least one Incident')
      }else {
        _this.checkedData =  _this.checkedData.filter((item)=>{
          return id !== item.uniqueId;
        })
      }
    },
    // 获取PDF默认信息
    getDefaultInfo:function () {
      _this.$ajax.get('GenerateReport/GetLastReportHeader').then(res=>{
        if (res.data.success){
          _this.$set(_this.generateInfo, "companyLogoBase64", res.data.data.companyLogo);
          _this.$set(_this.generateInfo, "letterHeader", res.data.data.letterHeader);
        }else {
          this.messageNotice("error",res.data.message)
        }
      })
    },
    changeExportVideo:function(){
      if(!_this.exportVideo){
        _this.limitFlag = false;
      }
    },
    /**
     * 输入处理
     */
    // header letter限制:最多4行;每行字段最多48个字符，达到最多字符时自动换行;用户编辑时可以回车换行
    handleLetterText:function() {
      let row = 0;
      let str = '';
      let arr = this.generateInfo.letterHeader.split("\n");
      arr.forEach((item,index) => {
        let curStr = item;
        let splitObj = this.getSplitStr(curStr, row);
        curStr = splitObj.str;
        row = splitObj.row;
        if(index === 0){
          str = curStr;
        }else{
          str = str + "\n" + curStr;
        }
      })
      LetterRow = row;
      this.generateInfo.letterHeader = str;
    },
    // 获取分割后的字符串(超过48字符换行),返回当前处理后的字符串和当前总行数
    getSplitStr:function(str, row){
      let outStr = "";
      // 已经4行及以上,当前行数不变,之后的字符串丢弃
      if(row >= 4){
        return {
          str:"",
          row:row
        }
      }
      let outRow = row + 1;
      let lenObj = this.getStrlen(str);
      // 真实字符长度大于48字符时
      if( lenObj.realLength > LetterRowSignNum){
        let sliceStr = str.slice(lenObj.splitLength, str.length);
        // 当前总行数小于4, 递归剪切字符
        if(outRow < 4){
          let splitObj = this.getSplitStr(sliceStr, outRow);
          outStr = str.slice(0, lenObj.splitLength ) + "\n" + splitObj.str;
          outRow = splitObj.row;
        // 当前总行数达到4, 返回剪切的前半部分字符串
        }else{
          outStr = str.slice(0, lenObj.splitLength );
        }
      // 真实字符长度不大于48字符时, 返回传入的字符
      }else{
        outStr = str;
      }
      return {
        str:outStr,
        curRow:row + 1,
        row:outRow
      }
    },
    // 获取字符串实际长度
    getStrlen:function(str){
      let realLength = 0, // 字符实际长度
        len = str.length, // 字符length
        charCode = -1, // 字符编码
        splitLength = null; // 分割的位置length
      for (let i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) {
          realLength += 1;
        }else{
          realLength += 2;
        }
        if(realLength === LetterRowSignNum){
          splitLength = i+1;
        }
      }
      return {
        realLength:realLength,
        splitLength:splitLength
      };
    },
    // header letter回车换行
    handleHeaderEnterUp:function(){
      if(LetterRow <= 4){
        if(/[\n]{1,}$/.test(this.generateInfo.letterHeader)){
          let str = "\n";
          if(!this.generateInfo.letterHeader || this.generateInfo.letterHeader.trim().length === 0 ){
            str = "";
          }
          this.generateInfo.letterHeader = this.generateInfo.letterHeader.replace(/[\n]+$/,str);
        }
      }else{
        this.generateInfo.letterHeader = this.generateInfo.letterHeader.replace(/[\n]+$/,"");
      }
    },
    // 点击上传
    clickUploadLogo:function(){
      $("#report-logo").click();
    },
    // 删除logo
    deleteIcon:function(){
      this.generateInfo.companyLogoBase64 = "";
      $("#report-logo").val("");
    },
    // 上传之前
    handleLogoUpload: function (e) {
      let fileLimit = 1; // 限制单位M
      const sizeErrMsg = "Support 'png','jpeg','jpg' format, and should not exceed " + fileLimit + "MB.";
      let file = e.target.files[0];
      if (!file || !file.size) {
        return;
      }
      // let acceptTypeArr = ["image/png", "image/x-png", "image/jpeg", "image/bmp"]; 根据提示不需要支持bmp因此注释
      let acceptTypeArr = ["image/png", "image/x-png", "image/jpeg"];
      if (file.size <= 1048576 * fileLimit) {
        if (acceptTypeArr.indexOf(file.type) > -1) {
          let fileNameArr = file.name.split(".")
          let fileFormat = fileNameArr[fileNameArr.length - 1];
          // 加入时间戳避免重复上传同一张图片时，名称相同页面刷新失败的问题
          this.logoFileName = new Date( _this.moment() ).getTime() + 'logo' + Math.floor( Math.random() * 1000000 ) + '.' + fileFormat;
          this.generateInfo.companyLogoName = file.name;
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            let imgBase64 = this.result.split(",")[1];
            _this.$set(_this.generateInfo, "companyLogoBase64", imgBase64);
            _this.$forceUpdate();
          };
        } else {
          e.target.value = "";
          _this.messageNotice('error', sizeErrMsg);
        }
      } else {
        e.target.value = "";
        _this.messageNotice('error', sizeErrMsg);
      }
    },
    //上传logo
    uploadLogoImg: function (imgBase64) {
      const blob = this.base64ToBlob(imgBase64);
      const file = this.blobToFile(blob, this.logoFileName);
      let form = new FormData();
      form.append("file", file);
      _this.$ajax.post('/api/Files/Upload/' + 'companyLogo', form, {
        headers: {
          contentType: "multipart/form-data"
        },
        baseURL: window.g.FILE_ROOT
      }).then(function (res) {
        if (res.data.success) {
          _this.$set(_this.generateInfo, "companyLogoBase64", res.data.data);
        } else {
          _this.$set(_this.generateInfo, "companyLogoBase64", "");
        }
      });
    },
    // 根据id更新logo
    updateShowLogo:function(id){
      this.$ajax.get('/api/Files/Get/' + id ,{
        responseType:"blob",
		    baseURL: window.g.FILE_ROOT
      }).then(function (res) {
        let blob = res.data;
        let reader = new FileReader();
        reader.onload = function(){
          _this.generateInfo.companyLogoBase64 = this.result;
        };
        reader.readAsDataURL(blob);
      });
    },
    // base64转blob
    base64ToBlob:function(base64Data) {
      let arr = base64Data.split(','),
          fileType = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          l = bstr.length,
          u8Arr = new Uint8Array(l);
      while (l--) {
        u8Arr[l] = bstr.charCodeAt(l);
      }
      return new Blob([u8Arr], {
        type: fileType
      });
    },
    // blob转file
    blobToFile:function(newBlob, fileName) {
      newBlob.lastModifiedDate = new Date();
      newBlob.name = fileName;
      return newBlob;
    },
    //上传格式错误
    handleFormatError() {
      _this.messageNotice('error', 'Please upload files in \'.eml\', \'.msg\', \'.png\', \'.gif\', \'.jpeg\', \'.jpg\', \'.txt\', \'.pdf\', \'.xlsx\', \'.xls\', \'.docx\', \'.doc\' format');
    },

    // 附件上传
    attachHandleUpload: function (file) {
      let formatStr = file.name.substr(file.name.lastIndexOf(".")+1).toLowerCase();
      let formatArr = ['eml','msg','png','gif','jpeg','jpg','txt','pdf','xlsx','xls','docx','doc','avi','mp4','mkv','mov'];
      if(formatArr.indexOf(formatStr) === -1){
        _this.messageNotice('error', "Support 'eml,msg,png,gif,jpeg,jpg,txt,pdf,xlsx,xls,docx,doc,avi,mp4,mkv,mov' format. Maximum file size is 15MB.");
        return;
      }
      let totalFileSize = 0;
      _this.generateInfo.attachments.forEach(item=>{
        let size = item.size;
        if (typeof size === 'string') {
          if (size.endsWith('K')) {
            totalFileSize += parseFloat(size) * 1024; // 将 KB 转换为字节
          } else if (size.endsWith('M')) {
            totalFileSize += parseFloat(size) * 1024 * 1024; // 将 MB 转换为字节
          } else {
            totalFileSize += parseFloat(size); // 直接作为字节处理
          }
        } else {
          totalFileSize += size; // 如果 size 是数字，直接累加
        }
      });
      if (totalFileSize + file.size < 1024 * 1024 * 15) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          let imgBase64 = this.result.substring(this.result.indexOf('base64,') + 7, this.result.length);
          let fileSize = file.size/1024;
          if(fileSize<1024){
            fileSize = Math.floor(fileSize*100)/100 + "K";
          }else{
            fileSize = Math.floor(fileSize/1024*100)/100 + "M";
          }
          _this.generateInfo.attachments.push({'attachmentBase64': imgBase64, 'fileName': file.name, 'fileSize': file.size , 'size' : fileSize});
        };
      } else {
        _this.messageNotice('error', "Support 'eml,msg,png,gif,jpeg,jpg,txt,pdf,xlsx,xls,docx,doc,avi,mp4,mkv,mov' format. Maximum file size is 15MB.");
      }
      return false;
    },




    // 删除附件
    deleteAttachment: function (index) {
      _this.generateInfo.attachments.splice(index, 1);
    },

    /**
     * 获取预览信息
     */
    // 获取PDF预览信息
    getPdfPreviewInfo: function () {
      if( _this.isFaceTrack ){
        _this.getFaceTrackingPreviewInfo();
      }else{
        _this.getIncidentPreviewInfo();
      }
    },
    // 获取事件预览的数据
    getIncidentPreviewInfo:function(){
      // 清空之前的预览信息
      _this.previewInfo = {
        head: _this.generateInfo,
        details: [],
        titleData:[]
      }
      let params = {};
      let url = 'Record/IncidentReport/Paging';
      if (_this.checkedData.length > 0) {
        let msgIds = [];
        _this.checkedData.forEach((event,index) => {
          if( index<5 ) {
            if(typeof event === 'string'){
              msgIds.push(event);
            }else {
              msgIds.push(event.id);
            }
          }
        });
        params.ids = msgIds;
      } else {
        params = JSON.parse(JSON.stringify(_this.searchParams));
        params.enabledPaging = true;
        params.page = 1;
        params.perPage = 10;
      }
      _this.$ajax.post(url,params).then(function (res) {
        if (res.data.success) {
          let detailData =  res.data.data.items;
          detailData.forEach(item=> {
            if (item.users && item.users.length > 0) {
              item.users.forEach(user => {
                if (user.snapFaceImageId) {
                  _this.shareApi.getImgUrl(user.snapFaceImageId).done((img) => {
                    _this.$set(user, 'photoImg', img);
                  })
                }
                if (user.userFaceId) {
                  _this.shareApi.getImgUrl(user.userFaceId).done((img) => {
                    _this.$set(user, 'sourceImg', img);
                  })
                }
                if (user.profilePhotoFileId) {
                  _this.shareApi.getImgUrl(user.profilePhotoFileId).done((img) => {
                    _this.$set(user, 'profilePhotoFile', img);
                  })
                }
              })
            }
            if(item.maps){
              item.devices = item.maps;
            }
            if (item.devices && item.devices.length) {
              item.devices.forEach( device => {
                device.locationTableData = [];
                if (device.mapUrl) {
                  _this.shareApi.getImgUrl(device.mapUrl).done((img) => {
                    _this.$set(device, "mapUrl", img);
                  });
                }
                // GPS 的Device out of boundary等3个事件
                if (item.incidentType === 12001 || item.incidentType === 12002 || item.incidentType === 12003 ) {
                  item.destinations = [];
                  device.deviceType = 9001;
                  try {
                    let dataObj = JSON.parse(item.extension);
                    item.destinations = dataObj.destinations;
                    device.battery = dataObj.devices[0].battery;
                    device.latitude = dataObj.devices[0].latitude;
                    device.longitude = dataObj.devices[0].longitude;
                  } catch (e) {
                    console.error(e);
                  }
                  let params = {
                    deviceId: device.deviceId,
                    incidentTime: item.createTime,
                    timeInterval: 1,
                    count: 10
                  };
                  _this.$ajax.post('Location/GetLocationForIncidentDetail', params, { 
                    headers: { noLoading: true },
                    baseURL: window.g.ATS_API_ROOT
                  }).then(res => {
                    if (res.data.success) {
                        device.locationTableData = res.data.data;
                    } else {
                        this.messageNotice('error', res.data.message);
                    }
                  });
                }
              })
            }
            if(item.esopRoles){
              let type0 = [];
              let type1 = [];
              let type2 = [];
              item.esopRoles.forEach((role)=>{
                role.receivers.forEach((element)=>{
                  if(element.receiveUserType === 0){
                    type0.push(element)
                  }
                  if(element.receiveUserType === 1){
                    type1.push(element)
                  }
                  if(element.receiveUserType === 2){
                    type2.push(element)
                  }
                })
                role.tasks.forEach((task)=>{
                  task.operateHistory = _this.getTaskSendInfo(task, item.operatorHistories || []);
                });
              });
                _this.$set(item,'esopAccounts',type0);
                _this.$set(item,'esopAccountGroups',type1);
                _this.$set(item,'esopSystemRoles',type2);
            }
            //task 上报延时记录获取
            // if(item.incidentCategory === 1 || item.incidentCategory === 2){
            //   _this.$ajax.get('IncidentRecord/GetTaskProcessHistoy?incidentRecordId=' + item.id,{baseURL: window.g.API_ROOT}).then(res=>{
            //     let array = res.data.data;
            //     array.forEach(item=>{
            //       if(item.type === 2) {
            //         _this.$set(item,'processTime',item.createTime);
            //       }
            //     })
            //     array.sort((a, b) => {
            //       return b.processTime - a.processTime;
            //     });
            //     _this.$set(item,'changeHistory',array);
            //   })
            // }
            if(_this.reportType !== 'alarmReport' && item.operatorHistories){
              _this.$set(item,'remarkText','');
              _this.$set(item,'isClose',false);
              _this.$set(item,'isAutomatic',false);
              _this.$set(item,'remarkNote',null);
              item.operatorHistories.forEach(it=>{
                if(it.mainRecord.operatorType === 3){
                  item.remarkText = (it.mainRecord.accountName ? it.mainRecord.accountName : 'The system') + (it.mainRecord.isAutomatic ? ' closed the incident automatically':' closed the incident') + ' at ' + _this.common.formatDate(it.mainRecord.createTime, _this.$root.Time[_this.$root.Time.type].typeTime, 1)
                  item.isClose = true;
                  if(it.mainRecord.isAutomatic){
                    item.isAutomatic = true;
                  }
                  if(it.note && it.note !== ''){
                    item.remarkNote = it.note;
                  }
                }
              })
            }
            item.operatorHistories.forEach(it=>{
              let supplementaryRemarkArr = []; 
              if(it.items && it.items.length > 0){
                it.items.forEach((noteItem)=>{
                   if(noteItem.taskOperateType == 8){
                     supplementaryRemarkArr.push(noteItem)
                   }
                })
                _this.$set(it,'supplementaryRemarkArr',supplementaryRemarkArr);
              }
              if(it.mainRecord.dispatchSecurityPersons && it.mainRecord.dispatchSecurityPersons.length > 0){
                let type0 = [];
                let type1 = [];
                let type2 = [];
                it.mainRecord.dispatchSecurityPersons.forEach(element => {
                  if(element.receiveUserType === 0){
                    type0.push(element)
                  }
                  if(element.receiveUserType === 1){
                    type1.push(element)
                  }
                  if(element.receiveUserType === 2){
                    type2.push(element)
                  }
                });
                _this.$set(it.mainRecord,'Accounts',type0);
                _this.$set(it.mainRecord,'AccountGroups',type1);
                _this.$set(it.mainRecord,'SystemRoles',type2);
              }
            });
            
          });
          setTimeout(function (){
            _this.previewInfo.details = detailData;
            _this.preViewModal = true;
          },200);
        }
      });
    },
    
    // 获取Track and Trace预览的数据
    getFaceTrackingPreviewInfo:function(){
      let params = _this.faceTrackingInfo.searchParams;
      let previewInfo = {
        titleData:[],
        head:{},
        details:{}
      };
      _this.$ajax.post('FaceTracking/Paginate', params).then(function (res) {
        if (res.data.success) {
          previewInfo.head = _this.generateInfo;
          previewInfo.isFace = _this.faceTrackingInfo.isFace;
          if( _this.faceTrackingInfo.isFace) {
            previewInfo.titleData = [
              {title: 'User Name', minWidth: 100,slot: 'userName'},
              {title: 'Access Zone', minWidth: 120,slot: 'accessZone'},
              {title: 'Device', minWidth: 80,slot: 'device'},
              {title: 'Detection Time', minWidth: 130,slot: 'time'},
              {title: 'Captured', minWidth: 90,slot: 'captureFace'},
              {title: 'Attachment', minWidth: 110,slot: 'attachment'},
            ]
          }else {
            previewInfo.titleData = [
              {title: 'Access Zone', minWidth: 120,slot: 'accessZone'},
              {title: 'Device', minWidth: 80,slot: 'device'},
              {title: 'Detection Time', minWidth: 130,slot: 'time'},
              {title: 'Captured', minWidth: 90,slot: 'captureFace'},
              {title: 'Attachment', minWidth: 110,slot: 'attachment'},
            ]
          }
          res.data.data.items.forEach( (user, index) => {
            if(user.userIdentityCards && user.userIdentityCards.length){
              user.idType = user.userIdentityCards[0].type;
              user.idNo = user.userIdentityCards[0].number;
            }
            if (user.localFaceFileId && index === 0) {
              user.sourceImg = "";
              _this.shareApi.getImgUrl(user.localFaceFileId).done((img) => {
                user.sourceImg = img;
                _this.previewInfo = previewInfo;
              })
            }
            if(user.devices && user.devices.length > 0 && index === 0){
              user.devices.forEach(device => {
                if(device.mapFileId) {
                  device.mapUrl = "";
                  _this.shareApi.getImgUrl(device.mapFileId).done((img) => {
                    device.mapUrl = img;
                    _this.previewInfo = previewInfo;
                  });
                }
              })
            }
          })
          previewInfo.tableData =  res.data.data.items
          previewInfo.details = res.data.data.items.slice(0,1);
          _this.previewInfo = previewInfo;
          _this.preViewModal = true;
        }else{
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
      })
    },
    //检查下载视频数量是否超过配置的最大数量
    checkVideoLimit:function(){
      let videoContent = 0;
      _this.checkedData.forEach(item => {
        if(item.cameraSourceIds && item.cameraSourceIds.length > 0){
          videoContent += item.cameraSourceIds.length;
        }
      })
      let amount = _this.generateType === 0 ? videoContent : _this.totalAmount;
      if(amount > _this.ApiService.videoLimit){
        _this.limitFlag = true;
      }
    },
    // 确认生成
    confirmGenerate: function () {
      if(_this.hasSpecialCharacters){return}
      if(_this.exportVideo){
        _this.checkVideoLimit();
        if(_this.limitFlag){
          let dom = document.getElementById('limit-tip-show');
          dom.scrollIntoView({behavior: "smooth"});
        }
      }
      _this.$validator.validateAll('generateInfo').then(result =>{
        let isAutoSendEmailFlag = false;
        if(_this.generateInfo.isAutoSendEmail){
          if(_this.emailSubject){
            _this.emailTitleFlag = false;
          }else {
            _this.emailTitleFlag = true;
          }
          if (_this.emailContent){
            _this.emailFlag = false;
          }else {
            _this.emailFlag = true;
          }
          _this.validateReceiver(0);

          if(!_this.receivers[0].receiverFlag && !_this.emailFlag && !_this.emailTitleFlag){
            isAutoSendEmailFlag = false;
          }else {
            isAutoSendEmailFlag = true
          }
        }
        if (result && !_this.limitFlag && !isAutoSendEmailFlag) {
          _this.sendBackStageReport();
        }
      })


    },
    // 发送generateReport报表
    sendBackStageReport: function () {
      let backStageInfo = JSON.parse(JSON.stringify(_this.generateInfo));
      backStageInfo.isHotizontal = false;
      backStageInfo.paperSize = 9;
      backStageInfo.companyLogo = backStageInfo.companyLogoBase64
      delete backStageInfo.companyLogoBase64;
      backStageInfo.type = _this.isFaceTrack ? 14 : 13;
      backStageInfo.exportVideo = _this.exportVideo;
      backStageInfo.sendFormat = _this.generateInfo.formatType;
      backStageInfo.requestParameter = _this.searchParams;
      if( backStageInfo.requestParameter && backStageInfo.requestParameter.enabledPaging ){
        backStageInfo.requestParameter.enabledPaging = false;
      }
      // 198bug -- 32327
      if(this.pageSource == 6){
        backStageInfo.requestParameter.IsFromInicdentNotificationReport = true
      }else{
        if(backStageInfo.requestParameter && backStageInfo.requestParameter.IsFromInicdentNotificationReport){
          delete backStageInfo.requestParameter.IsFromInicdentNotificationReport;
        }
      }
      if(_this.pageSource == 3 || _this.pageSource == 6){
        backStageInfo.requestParameter.isMyIncident = true
      }
      delete backStageInfo.requestParameter.page;
      delete backStageInfo.requestParameter.perPage;
      let params = {};
      let url = "GenerateReport/Create";
      if( _this.isFaceTrack ){
        backStageInfo.type = 14;
        params = JSON.parse(JSON.stringify( _this.faceTrackingInfo.searchParams ));
        params.enabledPaging = false;
        delete backStageInfo.requestParameter.page;
        delete backStageInfo.requestParameter.perPage;
      } else {
        if (!_this.pageSource || _this.pageSource === 0) {
          backStageInfo.type = 13;
          url = "Record/GenerateIncidentRecordReport";
        } else {
          url = "Record/GenerateMyIncidentRecordReport";
        }
        params = JSON.parse(JSON.stringify(_this.searchParams));
        params.ids = [];
        if( _this.checkedData.length && !_this.isAll){
          _this.checkedData.forEach( item=>{
            params.ids.push( item.id );
          })
        }else {
          params.ids = [];
        }
      }
      params.enabledPaging = false;
      delete params.page;
      delete params.perPage;
      backStageInfo.requestParameter = {
        headers: [],
        queryParameter: [params]
      };
      if(backStageInfo.isAutoSendEmail){
        backStageInfo.emailContent = _this.emailContent;
        backStageInfo.emailSubject = _this.emailSubject;
        backStageInfo.recipients = [];
        if (_this.receivers && _this.receivers.length) {
          _this.receivers.forEach(item => {
            if (item.receiverRoleIds && item.receiverRoleIds.length) {
              item.receiverRoleIds.forEach(role => {
                backStageInfo.recipients.push({type: 2, value: role});
              })
            }
            if (item.receiverGroupIds && item.receiverGroupIds.length) {
              item.receiverGroupIds.forEach(group => {
                backStageInfo.recipients.push({type: 1, value: group});
              })
            }
            if (item.receiverIds && item.receiverIds.length) {
              item.receiverIds.forEach(id => {
                backStageInfo.recipients.push({type: 0, value: id});
              })
            }
          })
        }
      }
      backStageInfo.loginUserId = _this.$root.adminInfo.id;
      backStageInfo.targetNodeId = _this.$root.curNodeInfo ? _this.$root.curNodeInfo.id : null;
      _this.$ajax.post(url, backStageInfo).then(function (res) {
        if (res.data.success) {
          _this.messageNotice('success');
          _this.generateModal = false;
        } else {
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
      });
    },
    /**************自动发送邮件*****************/
    changeAutoSend(val){
      if(val && _this.receivers && _this.receivers.length == 0){
        _this.addFormatReciver();
        _this.getSelectDate();
      }
    },
    getSelectDate:function(){
      let data = {
        enabledPaging:false,
        sortName:'name',
        sortType:0,
      }
      this.$ajax.post('Accounts/Options',data,{headers: {'noLoading': true},baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if(res.data.success){
          _this.selectedAccounts = res.data.data.items;
        }else{
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
      });
      this.$ajax.post('AccountGroups/PagingOption', data,{headers: {'noLoading': true} ,baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.selectedAccountGroups = res.data.data.items;
        } else {
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
      });
      this.$ajax.post('Roles/PagingOption', data,{headers: {'noLoading': true} ,baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.selectedRoles = res.data.data.items;
        } else {
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
      });
    },
    // 查看所有账号
    // openAccount: function (e,val) {
    //   _this.reciverType = val;
    //   if(val === 0 ){
    //     _this.getAllAccount();
    //     $(e.target).parents('.account-box').find('.utm-account-wapper0').slideDown(300);
    //   }else if (val === 1) {
    //     _this.queryAccountGroup();
    //     $(e.target).parents('.account-box').find('.utm-account-wapper1').slideDown(300);
    //   }else {
    //     _this.queryRole();
    //     $(e.target).parents('.account-box').find('.utm-account-wapper2').slideDown(300);
    //   }
    //   _this.roleName = '';
    //   _this.accountGroupName = '';
    //   _this.accountName = '';
    // },
     // 查看所有账号
     openAccount: function (e,val) {
      _this.reciverType = val;
      if( e.target.className == 'account-item-title'){
        if(val === 0 ){
          _this.accountName = '';
          _this.getAllAccount();
          $(e.target).parents('.account-box').find('.utm-account-wapper0').slideDown(300);
        }else if (val === 1) {
          _this.accountGroupName = '';
          _this.queryAccountGroup();
          $(e.target).parents('.account-box').find('.utm-account-wapper1').slideDown(300);
        }else {
          _this.roleName = '';
          _this.queryRole();
          $(e.target).parents('.account-box').find('.utm-account-wapper2').slideDown(300);
        }
      }
    },


    queryRole:function(){
      _this.reciverData.name = _this.roleName;
      let data = JSON.parse(JSON.stringify(_this.reciverData));
      this.$ajax.post('Roles/PagingOption', data,{headers: {'noLoading': true} ,baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.allRoleList = res.data.data.items;
        } else {
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
      });
    },
    //获取所有管理账号组
    queryAccountGroup: function () {
      _this.reciverData.name = _this.accountGroupName;
      let data = JSON.parse(JSON.stringify(_this.reciverData));
      this.$ajax.post('AccountGroups/PagingOption', data,{headers: {'noLoading': true} ,baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.allAccountGroupList = res.data.data.items;
        } else {
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
      });
    },
    addReceiverRole:function(data,index){
      let array = _this.receivers[index].receiverRoleIds.filter(item =>{
        return item.id == data.id;
      });
      if(array.length == 0){
        _this.receivers[index].receiverRoleIds.push(data.id);
      }
      _this.validateReceiver(index);
    },
    deleteReceiverRole:function(id,preIndex){
      let index = _this.receivers[preIndex].receiverRoleIds.indexOf(id);
      if(index === -1){
        _this.receivers[preIndex].receiverRoleIds.splice(index,1);
      }
      _this.validateReceiver(preIndex);
    },
    //获取所有管理员
    getAllAccount:function(){
      _this.reciverData.name = _this.accountName;
      let data = JSON.parse(JSON.stringify(_this.reciverData));
      this.$ajax.post('Accounts/Options',data,{headers: {'noLoading': true},baseURL: window.g.VERIFICATION_ROOT}).then(function (res) {
        if(res.data.success){
          _this.allAccountList = res.data.data.items;
        }else{
          if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
        }
        _this.scrollFlag = false;
      });
    },
    searchItem:function(type){
      clearTimeout(_this.timer);
      _this.timer = setTimeout(function(){
        if(type === 0 ){
          _this.getAllAccount();
        }else if (type === 1) {
          _this.queryAccountGroup();
        }else {
          _this.queryRole();
        }
      },1000);
    },
    // 新增账号组接收者
    addReceiverGroup:function (data,index) {
      let array = _this.receivers[index].receiverGroupIds.filter(item =>{
        return item.id == data.id;
      });
      if(array.length == 0){
        _this.receivers[index].receiverGroupIds.push(data.id);
      }
      _this.validateReceiver(index);
    },
    // 删除接收账号组
    deleteReceiverGroup:function (index,preIndex) {
      _this.receivers[preIndex].receiverGroupIds.splice(index,1);
      _this.validateReceiver(preIndex);
    },
    /*新增账号*/
    addReceiverAdmin:function(item,preIndex){
      let index = _this.receivers[preIndex].receiverIds.indexOf(item.id);
      if(index === -1){
        _this.receivers[preIndex].receiverIds.push(item.id);
      }
      _this.validateReceiver(preIndex);
    },
    /*删除账号*/
    deleteReceiverAdmin:function(item,preIndex){
      let index = _this.receivers[preIndex].receiverIds.indexOf(item.id);
      if(index > -1){
        _this.receivers[preIndex].receiverIds.splice(index,1);
      }
      _this.validateReceiver(preIndex);
    },
    // Receiver表单验证
    validateReceiver(index){
      let rec = _this.receivers[index].receiverGroupIds.length + _this.receivers[index].receiverIds.length + _this.receivers[index].receiverRoleIds.length;
      if(rec > 0){
        _this.receivers[index].receiverFlag = false;
      }else{
        _this.receivers[index].receiverFlag = true;
      }
    },
    // FileType表单验证
    validateFileType(index){
      if(_this.receivers[index].fileTypes && _this.receivers[index].fileTypes.length > 0){
        _this.receivers[index].formatFlag = false;
      }else{
        _this.receivers[index].formatFlag = true;
      }
    },
    deleteFormatReciver(index){
      if(_this.receivers.length > 1){
        _this.receivers.splice(index,1);
      }
    },
    // 打开编辑模板
    editEmailTemplate: function () {
      _this.cursorPosition = 0;
      _this.emailTitleFlag = false;
      _this.emailFlag = false;
      _this.emailTitle = _this.emailSubject;
      _this.emailText = _this.emailContent;
      _this.editEmailModal = true;
    },
    // 获取光标位置
    getCurPoint:function () {
      _this.cursorPosition  = this.$refs.myQuillEditor.quill.selection.savedRange.index;
    },
    // 验证邮箱模板信息
    validateEmail:function () {
      if(_this.emailText){
        _this.emailFlag = false;
      }else{
        _this.emailFlag = true;
      }
    },
    validateEmailSubject(){
      if(_this.emailTitle){
        _this.emailTitleFlag = false;
      }else{
        _this.emailTitleFlag = true;
      }
    },
    addFormatReciver(){
      let obj = {
        fileType: null,
        fileTypes: [],
        receiverGroupIds: [],
        receiverIds: [],
        receiverRoleIds :[],
        formatFlag: false,
        receiverFlag: false,
      }
      _this.receivers.push(obj);
    },
    // 保存模板信息
    saveTemplateInfo: function () {
      _this.validateEmail();
      _this.validateEmailSubject();
      if(!_this.emailFlag && !_this.emailTitleFlag) {
        _this.editEmailModal = false;
        _this.$set(_this,'emailSubject',_this.emailTitle);
        _this.$set(_this,'emailContent',_this.emailText);
        _this.$forceUpdate();
      }
    },
    /**************自动发送邮件*****************/
  },
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/reportGenerateComponent.js